import { render, staticRenderFns } from "./BscProInstList.vue?vue&type=template&id=2463d014"
import script from "./BscProInstList.vue?vue&type=script&lang=js"
export * from "./BscProInstList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports